import React, { useState } from "react";

import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";

import OPTIONS from "../../../../constant/Option";

import { RadioOptions } from "../../../../Global_Component/CustomInputComponent";

import {
  EditableTextField,
  EditableSelectField,
  EditableMultiSelectField,
} from "../../../../Global_Component/CustomInputComponent";
import {
  CustomSecondaryButton,
  CustomSecondaryDownLoadButton,
  CustomSecondaryEditButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";
const ApplicationForm = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [plantDetailn, setPlantDetail] = useState({
    name: "Savory Bite",
    ApplicateDatel: "01/01/2024",
    address: "Kohlapur aniya wada stara",
    lineAddress: "P block Anna Nagar Chennai",
    country: "India",
    state: "Bihar",
    city: "chennai",
    zipCode: "440025",
    website: "savorybite.com",
    phoneNumber: "7418529639",
    industryType: "Trade",
  });

  const [companyDetail, setCompanyDetail] = useState({
    name: "savorybite",
    applicationDate: "24/01/24",
    address: "Kohlapur aniya wada stara",
    lineAddress: "P block Anna Nagar Chennai",
    country: "India",
    state: "Bihar",
    city: "chennai",
    zipCode: "440025",
    website: "savorybite.com",
    phoneNumber: "7418529639",
    industryType: "Trade",
  });

  const [correspondacePerson,setCorrespondancePerson]=useState({
    firstName:"atif",
    lastName:"khan",
    designation:"manager",
    phoneNumber:"7414125893",
    landLine:"262625",
    email:"atif@gmail.com"

  })

  const [productDetail,setProductDetail]=useState({
    numberOfProduct:4,
    totalNumberOfProduct:10,
    productGroup:2,
    BrandsOfProduct:4,
    productVarieties:12
  })

  return (
    <>
      <Box sx={{px:2,my:2}}>
        <Grid sx={{display:"flex",justifyContent:"space-between"}}>
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
          Company Profile
        </Typography>

        <Box>
            {isEdit?null:<CustomSecondaryDownLoadButton label={"Download"} sx={{mx:2}}/>}
            <CustomSecondaryEditButton label={"Edit"} onClick={e=>setIsEdit(!isEdit)}/>
        </Box>
        </Grid>

        <Grid container sm={12} md={12} lg={8} xl={9} spacing={0}>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"name"}
              label={"Company/Businnes"}
              value={plantDetailn.name}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}></Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              multiline
              name={"address"}
              label={"Plant  Address"}
              value={plantDetailn.address}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              multiline={true}
              name={"line"}
              label={"Plant Line Address (optional)"}
              value={plantDetailn.lineAddress}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableSelectField
              name={"country"}
              options={OPTIONS.state.getAllOptions().map((option) => {
                return { value: option, label: option };
              })}
              label={"Country"}
              value={plantDetailn.country}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableSelectField
              name={"state"}
              options={OPTIONS.state.getAllOptions().map((option) => {
                return { value: option, label: option };
              })}
              label={"State"}
              value={plantDetailn.state}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"city"}
              label={"City"}
              value={plantDetailn.city}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"zipCode"}
              label={"Zip Code"}
              value={plantDetailn.zipCode}
              isEdit={isEdit}
            />
          </Grid>
        </Grid>

        <Grid
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 1,
          }}
        ></Grid>
      </Box>
<hr />
      <Box sx={{px:2,my:2}}>
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
           Manufacturing plant 
        </Typography>

        <Grid container sm={12} md={12} lg={8} xl={9} spacing={0}>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"name"}
              label={"Plant Name"}
              value={plantDetailn.name}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}></Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              multiline
              name={"address"}
              label={"Plant  Address"}
              value={plantDetailn.address}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              multiline={true}
              name={"line"}
              label={"Plant Line Address (optional)"}
              value={plantDetailn.lineAddress}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableSelectField
              name={"country"}
              options={OPTIONS.state.getAllOptions().map((option) => {
                return { value: option, label: option };
              })}
              label={"Country"}
              value={plantDetailn.country}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableSelectField
              name={"state"}
              options={OPTIONS.state.getAllOptions().map((option) => {
                return { value: option, label: option };
              })}
              label={"State"}
              value={plantDetailn.state}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"city"}
              label={"City"}
              value={plantDetailn.city}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"zipCode"}
              label={"Zip Code"}
              value={plantDetailn.zipCode}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <RadioOptions
              name="industryType"
              label={"Industry Type"}
              options={[
                { label: "Trade/Exporter", value: "Trade" },
                { label: "Self Manufacture", value: "selfManfacture" },
                {
                  label: "Contract Manufacturer",
                  value: "contractManufacturer",
                },
              ]}
              value={plantDetailn.industryType}
              onChange={(e) => {}}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, my: 1 }}>
            <RadioOptions
              label={"Name of Industry"}
              value={"Pharmaceutical"}
              options={[
                { label: "Food", value: "Food" },
                { label: "Non Food", value: "Non_Food" },
                { label: "Pharmaceutical", value: "Pharmaceutical" },
                { label: "Cosmeceutical", value: "Cosmeceutical" },
                { label: "Nutraceutical", value: "Nutraceutical" },
              ]}
              onChange={(e) => {}}
              isEdit={false}
            />
          </Grid>
        </Grid>

        
      </Box>
<hr />
      <Box sx={{px:2,my:2}}>

      <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
        Correspondace Person
        </Typography>

          <Grid
                container
                sm={12}
                md={12}
                lg={8}
                xl={9}
                spacing={0}
              >
               
        
                <Grid item md={6} sx={{p:1,m:0}}>
                <EditableTextField label={"First Name"} name={"firstName"} value={correspondacePerson.firstName} isEdit={isEdit}/>
                </Grid>
        
                <Grid item md={6} sx={{p:1,m:0}}>
                <EditableTextField label={"Last Name"} name='lastName' value={correspondacePerson.lastName} isEdit={isEdit}/>
                </Grid>
        
                <Grid item md={6} sx={{p:1,m:0}}>
                <EditableTextField label={"Designation"} name={correspondacePerson.designation} value={"Enter Here"} isEdit={isEdit}/>
                </Grid>
               
                <Grid item md={6} sx={{p:1,m:0}}>
                <EditableTextField label={"Contact Number (Phone)"} value={correspondacePerson.phoneNumber} isEdit={isEdit}/>
                </Grid>
        
        
                <Grid item md={6} sx={{p:1,m:0}}>
                <EditableTextField label={"Contact Number (Landline)"} value={correspondacePerson.landLine} isEdit={isEdit}/>
                </Grid>
        
        
                <Grid item md={6} sx={{p:1,m:0}}>
                <EditableTextField label={"Email"} name={"email"} value={correspondacePerson.email} isEdit={isEdit}/>
                </Grid>
              </Grid>
      </Box>
<hr />
      <Box
            sx={{
           px:2,
           py:1,
           my:2
            }}
          >
            <Typography
              variant="h6"
              sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
            >
            Product Detail
            </Typography>
      
            <Grid
              container
              sm={12}
              md={12}
              lg={8}
              xl={9}
              spacing={0}
            >
             
      
              <Grid item md={6} sx={{p:1,m:0}}>
              <EditableTextField label={"No of Product to be Halal Certified"} value={productDetail.numberOfProduct} isEdit={isEdit}/>
              </Grid>
              <Grid item md={6} sx={{p:1,m:0}}>
              <EditableTextField label={" Total No of Product in the P:lant"} value={productDetail.totalNumberOfProduct} isEdit={isEdit}/>
              </Grid>
              <Grid item md={6} sx={{p:1,m:0}}>
              <EditableTextField label={"Product Groups"} value={productDetail.productGroup} isEdit={isEdit}/>
              </Grid>
              <Grid item md={6} sx={{p:1,m:0}}>
              <EditableTextField label={"Brands of Products"} value={productDetail.BrandsOfProduct} isEdit={isEdit}/>
              </Grid>
              <Grid item md={6} sx={{p:1,m:0}}>
              <EditableTextField label={"Product Varieties"} value={productDetail.productVarieties} isEdit={isEdit}/>
              </Grid>
      
          
      
      
             
            </Grid>
      
            <Grid
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
        <CustomSecondaryButton label={"Back"}/>
          <CustomSuccessButton label={isEdit?"Save And Approved":"Approved"} />
        </Grid>
          </Box>
    </>
  );
};

export default ApplicationForm;
